import { render } from "./IconOpenInFull.vue?vue&type=template&id=3de5bd5a"
import script from "./IconOpenInFull.vue?vue&type=script&lang=js"
export * from "./IconOpenInFull.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__